/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface LoginRequestDto
 */
export interface LoginRequestDto {

    /**
     * @type {string}
     * @memberof LoginRequestDto
     */
    email: string;

    /**
     * @type {string}
     * @memberof LoginRequestDto
     */
    password: string;

    /**
     * @type {string}
     * @memberof LoginRequestDto
     */
    type: LoginRequestDtoTypeEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum LoginRequestDtoTypeEnum {
    Rfid = 'rfid',
    Pwd = 'pwd'
}

